import React from 'react';

import { TypographyList, TypographyListItem } from 'components/TypographyList';

import { IDescriptionTypographyList } from './interfaces';

const defaultGetLabel = ({ name }: { name: JSX.Element | string | number }) =>
  name;
const defaultGetIcon = ({ icon }: { icon: JSX.Element | string }) => icon;

export const DescriptionTypographyList: React.FC<
  IDescriptionTypographyList
> = ({
  value = [],
  item = TypographyListItem,
  getLabel = defaultGetLabel,
  getIcon = defaultGetIcon,
  iconFontSize,
  ...other
}) => {
  return (
    <TypographyList {...other}>
      {value?.map((opt, i) => {
        return React.createElement(
          item,
          {
            key: i,
            ...opt,
            iconProps: {
              fontSize: iconFontSize,
            },
            icon: getIcon(opt),
          },
          getLabel(opt)
        );
      })}
    </TypographyList>
  );
};
